import { computed, reactive } from 'vue';
import { useStore } from 'vuex';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { useSnackbar } from 'vue3-snackbar';

export default function useConsultaForm(service) {
    const store = useStore();
    const snackbar = useSnackbar();

    const state = reactive({
        id: '',
        name: '',
        status: 1,
    });

    const setState = (c) => {
        state.id = c.id;
        state.name = c.name;
        state.status = c.status;
    };

    /** ***** Validator ***** */
    const rules = computed(() => ({
        name: { required },
    }));

    const v = useVuelidate(rules, state);

    const resetForm = () => {
        v.value.$reset();
        state.id = '';
        state.name = '';
        state.status = 1;
    };

    const handleAction = async (action) => {
        if (await v.value.$validate()) {
            let text;
            switch (action) {
                case 'create':
                case 'create_view':
                    await service.createAyuda(state);
                    if (action === 'create_view') {
                        store.dispatch('ContentManager/openWindow', {
                            id: `AyudaDiagnosticaForm_${service.ayuda.value.id}`,
                            component: 'AyudaDiagnosticaForm_',
                            name: service.ayuda.value.name,
                            params: {
                                title: 'Consulta',
                                headerTitle: `Ver ${service.ayuda.value.name}`,
                                item: { ...service.ayuda.value },
                            },
                        });
                    }
                    text = 'Ayuda diagnostica creda con exito';
                    resetForm();
                    break;
                case 'save':
                    await service.updateAyuda(state.id, state);
                    text = 'Ayuda diagnostica actualizada con exito';
                    break;
                default:
                    break;
            }
            snackbar.add({
                type: 'success',
                text,
            });
        } else {
            console.log(v.$errors);
            snackbar.add({
                type: 'error',
                text: 'Ups no podemos enviar la informacion sin algunos datos',
            });
        }
    };

    return {
        v,
        state,
        setState,
        resetForm,
        handleAction,
    };
}
